import { apiClient } from './apiClient';

export const activityService = {
  getCompanyActivity: (companyId, { page = 0, size = 20, category = '', status = '', search = '', dateFrom = '', dateTo = '' } = {}) => {
    const params = new URLSearchParams({ page, size });
    if (category) params.append('category', category);
    if (status)   params.append('status', status);
    if (search)   params.append('search', search);
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo)   params.append('dateTo', dateTo);
    return apiClient.get(`/api/activity/company/${companyId}?${params}`);
  },

  getCompanyStats: (companyId) =>
    apiClient.get(`/api/activity/company/${companyId}/stats`),
};
